export default __webpack_public_path__ + "images/606443a36466e4099314914a049e7f62.svg";